import React, { useState } from "react";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import { useOnClickOutsideTwo } from "../../../utils/useClickOutside";
import "./ActionIconFragment.css";

type objProp = {
  icon?: any;
  label: string;
  onClick?: (param?: any) => void;
  textColor?: string;
  hide?: boolean;
};

interface myComponentProps {
  list?: objProp[];
  detail?: any;
  dotIcon?: React.ReactNode;
  dropPosition?: string;
}

const DotActionDropFragment = ({
  detail,
  list,
  dotIcon,
  dropPosition,
}: myComponentProps) => {
  const [showDrop, setShowDrop] = useState<boolean>(false);

  const dropFuncRef = useOnClickOutsideTwo(() => {
    setShowDrop(false);
  });

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className="icon-dot-drop-general-reuse-wrapper-table-index"
      ref={dropFuncRef}
      style={{ zIndex: showDrop ? 10 : 1 }}
    >
      {/* dot icon start */}
      <div
        onClick={() => {
          setShowDrop(!showDrop);
        }}
        className="drop-icon"
      >
        <figure className="img-box">{dotIcon || ALL_ICONS?.action_dots}</figure>
      </div>
      {/* dot icon end */}
      {/* drop box start */}
      {showDrop && (
        <div className={`drop-box-wrap ${dropPosition === "top" ? 'drop-box-wrap-top' : ""}`}>
          {list?.map((chi, idx) => {
            if (chi?.hide) {
              return <React.Fragment key={idx}></React.Fragment>;
            }
            return (
              <div
                onClick={() => {
                  chi?.onClick && chi?.onClick(detail);
                  setShowDrop(false);
                }}
                key={idx}
                className="row-item"
              >
                {chi?.icon && (
                  <div className="icon-box">
                    <figure className="img-box">{chi?.icon}</figure>
                  </div>
                )}
                <p style={{ color: chi?.textColor || "" }} className="label">
                  {chi?.label || ""}
                </p>
              </div>
            );
          })}
        </div>
      )}
      {/* drop box end */}
    </div>
  );
};

export default DotActionDropFragment;
